export const FORM_QUALITY_SEAL = {
  fecha: "",
  foliosDel: "",
  al: "",
  maquina: "",
  noOT: "",
  cliente: "",
  logotipo: "",
  proceso: "IMPRESION",
  procesoOtro: "",
  turno: "1er",
  tipoFolio: "", // 👈 NUEVO CAMPO
  horaInicio: "",
  horaTermino: "",
  totalEntregadas: "",
  modelo: "",
  longitud: "",
  color: "",
  mermasDefecto: "",
  mermasErrorHumano: "",
  mermasRecupera: "",
  pruebasCalidad: "",
  observaciones: "",
};